import React from 'react'
import styles from './styles.module.scss'
import Celebrate from './Celebrate'
import WhatsNew from './WhatsNew'
import { useSelector } from 'react-redux'
import SectionTitle from '../common/SectionTitle'
import { useTranslation } from 'react-i18next'

function NotableEvents({ data, groupId, groupName, showUserLightModal }) {
  const { t } = useTranslation()
  const {
    dashboardDetail: { loading }
  } = useSelector((state) => state)
  return (
    <React.Fragment>
      <SectionTitle title={t('dashboard.post.whatsNew')} />
      <div className={styles.notableEvents}>
        <WhatsNew
          newData={data?.Whats_new}
          loading={loading}
          showUserLightModal={showUserLightModal}
          isExpanded={!(data?.One_thing_to_celebrate?.length > 0)}
        />
        {data?.One_thing_to_celebrate?.length > 0 && (
          <Celebrate
            celebrateData={data?.One_thing_to_celebrate}
            groupId={groupId}
            showUserLightModal={showUserLightModal}
          />
        )}
      </div>
    </React.Fragment>
  )
}

export default NotableEvents
